import React from 'react'
import DentalDrawer from '../../components/drawers/dental'
import BilledQueue from '../../components/pages/billedQueue'

const Procedures = () => {
    return (
        <BilledQueue
            category="Dental"
            basePath="/app/dental/procedures"
            DrawerComponent={DentalDrawer}
            forwardSource="Dental"
            requestDepartment="Dental"
        />
    )
}

export default Procedures
